import React from 'react';
import { useFlow } from '../utilities/useFlow';

export default function Footer(): JSX.Element | null {
  const flow = useFlow();

  if (flow !== 'Keepr') {
    return null;
  }

  return (
    <footer className="App-footer">
      <div className="footer-content">
        <div className="van-container">
          <img
            alt="Delivery van"
            loading="lazy"
            width="192"
            height="100"
            className="van-image"
            src="/img/van.png"
          />
        </div>
      </div>
    </footer>
  );
}
